import { Availability } from './Availability';
import { EmployeePositionId } from './Employee';

/**
 * A class represents employee's availabilities.
 */
export class StoreEmployeeAvailability {
  employeePositionId: EmployeePositionId;
  availabilities: Map<string, Availability[]>;

  /**
   * @param employeePositionId the identifier of the employee and its position.
   * @param availabilities a map of employee's availabilities, grouped by the date on which they take effect.
   */
  constructor(employeePositionId: EmployeePositionId, availabilities: Map<string, Availability[]>) {
    this.employeePositionId = employeePositionId;
    this.availabilities = new Map(availabilities);
  }
}
